// NOTE: We use this page instead of NextJS default 404 page. We can't use 404 because it's
// static by default and we can't use getInitialProps with it.
// Source: https://github.com/vercel/next.js/blob/master/errors/404-get-initial-props.md
//
// We need to use getInitialProps to get url from which user was redirected.
//
// Also static 404 didn't have access to saved values in App Context as it's described in
// this alternative approach. I guess it happens because we do had redirect in withApollo
// Source: https://stackoverflow.com/a/55581074/11197103

import { useContext } from "react";
import { NextPageContext } from "next";
import { Trans } from "@lingui/macro";
import { getI18nRoute } from "src/utils/i18nRoutes";
import { AppCtx } from "src/contexts/app.context";
import Error from "./_error";

interface Props {
  pageProps: {
    redirectUrl?: string;
    statusCode?: string;
  };
}

const NotFound = (props: Props): JSX.Element => {
  const { locale } = useContext(AppCtx);
  const { redirectUrl } = props.pageProps;

  const genderIds = ["men", "women", "kids"];
  const brandRoutes = genderIds.map((genderId) =>
    getI18nRoute({
      route: `/brands`,
      locale,
    })
  );

  const isBrandPage = brandRoutes.some(
    (brandRoute) => redirectUrl && redirectUrl.includes(brandRoute)
  );

  const href = isBrandPage ? redirectUrl : "/";

  const text = (
    <>
      <Trans>It looks like this product isn’t available right now.</Trans>
      <br />
      <Trans>
        Please check back later or look at the other great items we have
        available.
      </Trans>
    </>
  );

  return <Error href={href} text={text} />;
};

NotFound.getInitialProps = (ctx: NextPageContext) => {
  return {
    redirectUrl: ctx?.req?.headers.referer,
  };
};

export default NotFound;
